import React from "react";
import { Table, Tag, Space, Badge } from "antd";
import { FiAlertTriangle } from "react-icons/fi";

export default function VulnerabilitiesTab() {
	const vulnData = [
		{
			id: 1,
			vulnId: "CVE-2024-1001",
			assetName: "SCADA-SERVER-01",
			type: "Remote Code Execution",
			cvssScore: 9.8,
			severity: "Critical",
			affectedVersion: "3.5.1",
			discovered: "2024-01-10",
			status: "Open",
		},
		{
			id: 2,
			vulnId: "CVE-2024-1002",
			assetName: "COMPUTER-WS-06",
			type: "Privilege Escalation",
			cvssScore: 8.4,
			severity: "High",
			affectedVersion: "2.1.0",
			discovered: "2024-01-08",
			status: "Open",
		},
		{
			id: 3,
			vulnId: "CVE-2024-1003",
			assetName: "HMI-WORKSTATION-02",
			type: "Cross-Site Scripting",
			cvssScore: 6.5,
			severity: "Medium",
			affectedVersion: "1.8.2",
			discovered: "2024-01-12",
			status: "In Progress",
		},
		{
			id: 4,
			vulnId: "CVE-2024-1004",
			assetName: "INDUSTRIAL-PLC-03",
			type: "Denial of Service",
			cvssScore: 7.2,
			severity: "High",
			affectedVersion: "4.2.3",
			discovered: "2024-01-05",
			status: "Patched",
		},
		{
			id: 5,
			vulnId: "CVE-2024-1005",
			assetName: "NETWORK-DEVICE-04",
			type: "Information Disclosure",
			cvssScore: 5.1,
			severity: "Medium",
			affectedVersion: "2.0.1",
			discovered: "2024-01-14",
			status: "Open",
		},
	];

	const getSeverityColor = (severity) => {
		const colorMap = {
			Critical: "#ff4d4f",
			High: "#ff7a45",
			Medium: "#faad14",
			Low: "#52c41a",
		};
		return colorMap[severity];
	};

	const getCVSSColor = (score) => {
		if (score >= 9) return "#ff4d4f";
		if (score >= 7) return "#ff7a45";
		if (score >= 5) return "#faad14";
		return "#52c41a";
	};

	const getStatusColor = (status) => {
		const colorMap = {
			Open: "#ff4d4f",
			"In Progress": "#faad14",
			Patched: "#52c41a",
		};
		return colorMap[status];
	};

	const columns = [
		{
			title: "CVE ID",
			dataIndex: "vulnId",
			key: "vulnId",
			width: 120,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Vulnerability Type",
			dataIndex: "type",
			key: "type",
			width: 180,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "CVSS Score",
			dataIndex: "cvssScore",
			key: "cvssScore",
			width: 110,
			render: (score) => (
				<Tag
					color={getCVSSColor(score)}
					className="border-0"
					style={{ color: "#fff", fontSize: "14px", fontWeight: "bold" }}
				>
					{score}
				</Tag>
			),
		},
		{
			title: "Severity",
			dataIndex: "severity",
			key: "severity",
			width: 100,
			render: (severity) => <Tag color={getSeverityColor(severity)}>{severity}</Tag>,
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 110,
			render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
		},
		{
			title: "Discovered",
			dataIndex: "discovered",
			key: "discovered",
			width: 120,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Action",
			key: "action",
			width: 100,
			render: (_, record) => (
				<Space size="small">
					<button
						type="button"
						className="btn btn-sm btn-primary fw-bold"
					>
						Remediate
					</button>
				</Space>
			),
		},
	];

	return (
		<div className="card mt-5">
			<div className="card-body">
				<Table
					columns={columns}
					dataSource={vulnData}
					rowKey="id"
					className="table antd-override mb-0"
					pagination={{
						pageSize: 10,
						className: 'mb-0',
						showTotal: (total, range) => (
							<span>
								{range[0]} to {range[1]} of {total} vulnerabilities
							</span>
						),
					}}
					scroll={{ x: 1200 }}
				/>
			</div>
		</div>
	);
}
